import * as R from 'ramda';
import sportsApi from '../../utils/sportsApi';

const updateCollection = store => async (state, id, values) => {
    const userClientId = state.user.selectedUserClientId;
    const clientId = state.user.selectedClientId;

    if (values.name || values.description) {
        await sportsApi
            .url(`/clients/${clientId}/collections/${id}`)
            .json({
                domainObject: {
                    ...(values.name && { name: values.name }),
                    ...(values.description && {
                        description: values.description,
                    }),
                },
            })
            .put()
            .json();
    }

    const collection = state.clients[userClientId].collections.list.items[id];
    const newCollection = {
        ...collection,
        ...(values.name && { name: values.name }),
        ...(values.description && { description: values.description }),
      ...(values.jobStatus && { jobStatus: values.jobStatus }),
    };

    store.setState(
        R.evolve(
            {
                clients: {
                    [userClientId]: {
                        collections: {
                            list: {
                                items: {
                                    [collection.id]: R.always(newCollection),
                                },
                            },
                        },
                        filters: {
                            collections: {
                                list: R.assocPath(
                                    [collection.id],
                                    newCollection,
                                ),
                            },
                        },
                    },
                },
            },
            store.getState(),
        ),
        true,
    );
};

export default updateCollection;
